
import Vue from 'vue';
import RunnitPageGraphicSVG from '@/assets/RunnitPageGraphicSVG.vue';

export default Vue.extend({
	name: 'RunnitTemplatesOnboardingBanner',
	components: {
		RunnitPageGraphicSVG,
	},
	props: {
		maxWidth: {
			type: String,
			default: '1610px',
		},
	},
});
